import React, { useState } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Row,
  Col
} from 'reactstrap'
import Tabs from 'react-responsive-tabs'
import _ from 'lodash'
import Moment from 'moment'
import DatePicker from 'react-datepicker'

import General from './General'
import Medical from './Medical'
import CreditAdvance from './CreditAdvance'
import Appointments from './Appointments'
import Settings from './Settings'
import LoadingOverlay from 'components/Indicator/LoadingOverlay' 

const TabsConfig = {
  activeTab: 0,
  showMore: true,
  transform: true,
  showInkBar: true,
  items: [
    { title: 'General' },
    { title: 'Medical' },
    { title: 'Credit Advance' },
    { title: 'Appointments' },
    { title: 'Settings' }
  ],
  selectedTabKey: 0,
  transformWidth: 400,
}

const Update = ( props ) => {
  const [ currentTab, updateCurrentTab ] = useState( 0 )
  const [ showExportModal, setShowExportModal ] = useState( false )
  const [ startDate, setStartDate ] = useState( null )
  const [ endDate, setEndDate ] = useState( null )

  let {
    showUpdatePatient,
    getSelectedPatient,
    selectedPatient,
    onChangePatientsHOC,
    onLoadPatients,
    updatePatient,
    getMedicalRecords,
    uploadPhoto,
    currencies,
    panels,
    downloadInvoicePatientReport
  } = props

  const handleExportReport = () => {
    if( startDate && endDate ) {
      const formattedStartDate = Moment( startDate ).format( 'YYYY-MM-DD' )
      const formattedEndDate = Moment( endDate ).format( 'YYYY-MM-DD' )
      downloadInvoicePatientReport( selectedPatient.id, selectedPatient.name, formattedStartDate, formattedEndDate )
      setShowExportModal( false )
      setStartDate( null )
      setEndDate( null )
    }
  }

  const onChangePatientData = ( key, val ) => {
    let tmp = _.cloneDeep( selectedPatient )
    tmp[ key ] = val
    return onChangePatientsHOC( 'selectedPatient', tmp )
  }

  return (
    <Modal
      isOpen={ showUpdatePatient }
      size={ 'xl' }
      toggle={() => {
        onChangePatientsHOC( 'showUpdatePatient', false )
      }}>
      <ModalHeader toggle={() => onChangePatientsHOC( 'showUpdatePatient', false )}>Update patient</ModalHeader>
      <ModalBody>
        <Tabs
          tabsWrapperClass="body-tabs"
          { ...TabsConfig }
          selectedTabKey={ currentTab }
          onChange={ val => updateCurrentTab( val ) } />
        {
          currentTab === 0 && <General 
            onChangePatientData={ onChangePatientData } 
            selectedPatient={ selectedPatient } 
            uploadPhoto={ uploadPhoto } 
            onChangePatientsHOC= { onChangePatientsHOC }
            panels={ panels } />
        }
        {
          currentTab === 1 && <Medical onChangePatientData={ onChangePatientData } selectedPatient={ selectedPatient } />
        }
        {
          currentTab === 2 && <CreditAdvance 
            onChangePatientData={ onChangePatientData } 
            selectedPatient={ selectedPatient } 
            currencies={ currencies }
            getSelectedPatient={ getSelectedPatient } />
        }
        {
          currentTab === 3 && <Appointments selectedPatient={ selectedPatient } />
        }
        {
          currentTab === 4 && <Settings { ...props } />
        }
        { onLoadPatients && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        {
          currentTab !== 2
            && (
              <Button
                color="primary"
                onClick={() => {
                  updatePatient( selectedPatient )
                }}>
                Submit
              </Button>
            )
        }
        <Button
          color="primary"
          onClick={() => setShowExportModal( true )}>
          Export Patient Collection Report
        </Button>
        <Button
          color="primary"
          onClick={() => {
            getMedicalRecords( selectedPatient.id )
          }}>
          View treatment record
        </Button>
      </ModalFooter>
      <Modal isOpen={ showExportModal } toggle={() => setShowExportModal( false )}>
        <ModalHeader toggle={() => setShowExportModal( false )}>
          Export Patient Collection Report
        </ModalHeader>
        <ModalBody>
          <p>Select a date range to export invoices for <strong>{ selectedPatient.name }</strong></p>
          <Row>
            <Col md={ 6 }>
              <FormGroup>
                <Label>Start Date</Label>
                <DatePicker
                  className="form-control"
                  selected={ startDate }
                  onChange={ date => setStartDate( date ) }
                  dateFormat="yyyy-MM-dd"
                  maxDate={ endDate || new Date() }
                  placeholderText="Select start date"
                />
              </FormGroup>
            </Col>
            <Col md={ 6 }>
              <FormGroup>
                <Label>End Date</Label>
                <DatePicker
                  className="form-control"
                  selected={ endDate }
                  onChange={ date => setEndDate( date ) }
                  dateFormat="yyyy-MM-dd"
                  minDate={ startDate }
                  maxDate={ new Date() }
                  placeholderText="Select end date"
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => {
            setShowExportModal( false )
            setStartDate( null )
            setEndDate( null )
          }}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={ handleExportReport }
            disabled={ !startDate || !endDate }>
            Export
          </Button>
        </ModalFooter>
      </Modal>
    </Modal>
  )
}

export default Update